import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import { GET_TRANSFORM_SQL } from './types.js';

export const INITIAL_STATE = {
    byEntityId: {}
};

export const transformSqlReducer = produce((draft, action) => {
    switch (action.type) {
        case GET_TRANSFORM_SQL.STARTED: {
            const entityId = action.payload.uuid;

            draft.byEntityId[entityId] = {
                isLoading: true,
                sql: null,
                error: null
            };

            break;
        }
        case GET_TRANSFORM_SQL.SUCCEEDED: {
            const entityId = action.meta.uuid;
            draft.byEntityId[entityId].sql = action.payload.sql;

            break;
        }
        case GET_TRANSFORM_SQL.FAILED: {
            const entityId = action.meta.uuid;
            const error = extractError(action.payload);

            draft.byEntityId[entityId] = {
                sql: null,
                error
            };
            break;
        }
        case GET_TRANSFORM_SQL.ENDED: {
            const entityId = action.meta.uuid;

            draft.byEntityId[entityId].isLoading = false;

            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
